module.exports = __webpack_public_path__ + "static/img/toolbox-table.5b5eb6ec.svg";